import { defineMessages } from 'react-intl';

export default defineMessages({
  filter: 'Filter',

  all: 'All',
  voting: 'Voting',
  executed: 'Executed',
  failed: 'Failed',
  queued: 'Queued',
  pending: 'Pending',
  canceled: 'Canceled',
  passed: 'Passed',
  expired: 'Expired',
});
